import { makeStyles } from '@material-ui/core'

import { lang } from '../../../localization'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: ({ depth }: { depth: number }) => {
      return lang === 'en' ? (depth - 1) * 10 : undefined
    },
    paddingRight: ({ depth }: { depth: number }) => {
      return lang === 'fa' ? (depth - 1) * 10 : undefined
    }
  },
  channelRow: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    backgroundColor: ({ depth }: { depth: number }) =>
      depth === 1
        ? theme.palette.grey[300]
        : depth === 2
        ? theme.palette.grey[200]
        : theme.palette.grey[100]
  },
  channelName: {
    marginLeft: 8
  },
  arrowIconContainer: {
    position: 'absolute',
    right: 0
  },
  layer: {
    marginTop: 10
  },
  expandableBoxRowContainer: {
    marginTop: 10
  },
  expandableBoxRowContainerDisabled: { opacity: '80%' },
  middle: {
    textAlign: 'center'
  }
}))

export default useStyles
